export function createResumeByProductPrompt(
  productDescription: string,
  customer: { firstName: string; lastName: string; gender: string }
) {
  return `
Create a detailed target customer profile based on the following product description. The customer's name is ${customer.firstName} ${customer.lastName} and their gender is ${customer.gender}.

The customer most recent company and position should be a company and position that are in the user segments or end users to the product given at the end. The customer should have relevant use case of the product. The customer should not be the creator of the product.

For example, if the product is an education innovation, the customer should be schools, teachers, students, or parents. If the product is a health innovation, the customer should be hospitals, doctors, patients, or caregivers.

Include the following elements in your profile:
1. 3-5 specific pain points the customer may experience
2. Work Experience
3. Most recent company
4. Most recent position
5. Project Experience
6. Education
7. Skills
8. Certifications
9. Awards
10. Publications
11. Languages
12. Interests
13. References
14. Personal Information
15. Other relevant details

Ensure the profile aligns with the product description provided below:

<PRODUCT_DESCRIPTION>
${productDescription}
</PRODUCT_DESCRIPTION>

Craft a comprehensive and realistic profile that demonstrates how this customer would benefit from the described product.
  `;
}

export function createResumeByProductFunctions() {
  return [
    {
      name: 'createCustomerProfile',
      description: 'Create a detailed target customer profile based on a product description',
      parameters: {
        type: 'object',
        properties: {
          painPoints: {
            type: 'array',
            description: '3-5 specific pain points the customer may experience',
            items: { type: 'string' },
            minItems: 3,
            maxItems: 5,
          },
          personalInformation: { type: 'string', description: "Customer's personal information" },
          workExperience: { type: 'string', description: "Customer's work experience. Extract specific details, do not miss any information, do not change words, do not summarize, do not remove numbers." },
          mostRecentCompany: { type: 'string', description: "Customer's most recent company" },
          mostRecentPosition: { type: 'string', description: "Customer's most recent position" },
          projectExperience: { type: 'string', description: "Customer's project experience" },
          education: { type: 'string', description: "Customer's education" },
          skills: { type: 'array', description: "Customer's skills", items: { type: 'string' } },
          certifications: { type: 'array', description: "Customer's certifications", items: { type: 'string' } },
          awards: { type: 'array', description: "Customer's awards", items: { type: 'string' } },
          publications: { type: 'array', description: "Customer's publications", items: { type: 'string' } },
          languages: { type: 'array', description: 'Languages spoken by the customer', items: { type: 'string' } },
          interests: { type: 'array', description: "Customer's interests", items: { type: 'string' } },
          references: { type: 'array', description: "Customer's references", items: { type: 'string' } },
          otherDetails: { type: 'string', description: 'Other relevant details about the customer' },
        },
        required: ['painPoints', 'workExperience', 'mostRecentCompany', 'mostRecentPosition', 'education', 'skills'],
      },
    },
  ];
}
